const summariseOrder = (basket, mfl = false) => {
  let subtotal = 0;
  let vat = 0;
  let mflFactor = mfl ? 0.8 : 1;
  let mflSubtotal = 0;

  const incrementAmounts = (runningTotal, vatApplicable, familyID) => {
    const mflFamilyID = 5;
    if (familyID === mflFamilyID) {
      // do the mfl discount
      mflSubtotal += runningTotal;
      runningTotal *= mflFactor;
    }
    subtotal += runningTotal;

    // if vatApplicable is null or not a string, set it to 1
    vat += (runningTotal / 100) * (Number(vatApplicable) || 0);
  };

  basket.forEach(item => {
    //  this relies on if you can buy multiple and if not then we accept we must be
    // able to add multiple users - IF this changes then this will be a breaking change

    if (item.canOrderMultiple) {
      const runningTotal =
        parseFloat(item.price) * parseFloat(item.packageQuantity);
      incrementAmounts(runningTotal, item.vatApplicable, item.familyID);
    } else {
      let runningTotal =
        parseFloat(item.price) +
        parseFloat(item.additionalUsers) * parseFloat(item.extrauserprice);
      incrementAmounts(runningTotal, item.vatApplicable, item.familyID);
    }
  });



  const total = subtotal + vat;

  return {
    subtotal,
    vat,
    total
  };
};

export { summariseOrder };
